import React from 'react';

import { styled } from '@mui/material/styles';
import { Color } from '../../theme';

const Container = styled('footer')`
  background-color: ${Color.grayDarkest};
  padding: 40px;

  & .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-grow: 1;
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 12px;

    p.copy {
      padding: 0;
      margin-top: 0;
    }
  }

  .footer-nav {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    font-size: 0.8rem;
  }

  .footer-nav li a:link,
  .footer-nav li a:visited {
    text-decoration: none;
    border: 0;
    color: ${Color.grayLight};
  }

  .footer-nav li a:hover,
  .footer-nav li a:active {
    color: ${Color.gray};
    transition: color 0.2s;
  }

  .copy {
    text-align: center;
    color: ${Color.grayLight};
    font-size: 0.8rem;
    margin-top: 20px;
  }

  @media only screen and (max-width: 767px) {
    .row {
      flex-direction: column;
    }

    .footer-nav {
      flex-direction: column;
    }
  }
`;

function Footer() {
  return (
    <Container>
      <div className='column centered'>
        <ul className='footer-nav'>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href='#'>Home</a>
          </li>
          <li>
            <a href='#products'>Products</a>
          </li>
          <li>
            <a href='#about'>About</a>
          </li>
          <li>
            <a href='#contact'>Contact Us</a>
          </li>
        </ul>
        <p className='copy'>
          Serving Conway, Myrtle Beach, and the Horry County Region
        </p>
        <p className='copy'>
          Copyright &copy; 2026 Coastal Ready Mix, LLC. All rights reserved.
        </p>
      </div>
    </Container>
  );
}

export default Footer;
